import { api_base_url } from "../../../constants";
import { getAppLocale } from "../../../utils/app-locale";
import { appConfiguration } from "../../../utils/app-starter";
import { API_INSTANCE } from "../../../utils/service-http"

export const getCompatibleRedboxes = (config) => {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';
  return API_INSTANCE.post(`${api_base_url}/configurations/${config.id}/compatible-redboxes?locale=${getAppLocale()}${mainOverrideString}`, {})
    .then((success) => {
      return success.data.payload.compatibleRedboxes;
    }).catch((error) => {
      throw error;
    });
}
